import React, {  Component } from 'react';

export default class ProductsInTheCartOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("ProductsInTheCartOverlayDialog", false);
    }
	howToHandleCartItems(action, event) {
		const self = this;
		self.props.howToHandleCartItems(action);
		self.closeDialog(event);
	}
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
					<a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Products in Cart</h2>
					<p>There are currently products in the cart. Do you want to combine all products on an order or delete the Cart and start an order with only these products?</p>
                    <a style={{width: '39%', fontSize: '12px',textAlign: 'center'}} className="blueButton noButton" onClick={this.howToHandleCartItems.bind(this, 'combine')}>Combine with products in Cart</a>
					<a style={{width: '39%', fontSize: '12px',textAlign: 'center'}} className="blueButton yesButton" onClick={this.howToHandleCartItems.bind(this, "delete")}>Delete Cart and create order</a>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/productsInTheCartOverlayDialog.js